// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_MIT","cls2":"ArticlesFilters-cls2_-0W ArticlesFilters-cls1_MIT"};